import { createStore, combineReducers } from 'redux';
import mapReducer from './features/map/reducer';
import { Provider } from 'react-redux';
import React from 'react';
import MapRouter from './features/router/components/map-router';
import { organizersReducer } from '../service/organizers';
import kretsReducer from '../catalog/krets-reducer';
import Breadcrumbs from './features/breadcrumb/components/breadcrumbs';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { mapRouterReducer } from './features/router/reducer';

function init(): void {
  console.info('loading map page');
  const store = createStore(
    combineReducers({
      map: mapReducer,
      selectedKrets: kretsReducer,
      organizers: organizersReducer,
      router: mapRouterReducer,
    })
  );
  const mapDiv = document.getElementById('sxk-map');
  if (mapDiv) {
    const appDiv = document.getElementById('app');
    appDiv.className = 'layout-one-sidebar clearfix';
    const root = createRoot(mapDiv);
    root.render(
      <Provider store={store}>
        <BrowserRouter>
          <MapRouter />
        </BrowserRouter>
      </Provider>
    );

    const breadcrumbsOl = document.getElementById('system-breadcrumb')?.parentElement?.querySelector('ol');
    if (breadcrumbsOl) {
      const root = createRoot(breadcrumbsOl);
      root.render(
        <Provider store={store}>
          <BrowserRouter>
            <Routes>
              <Route path="/sjokort" element={<Breadcrumbs />} />
              <Route path="/sjokort/:slug" element={<Breadcrumbs />} />
              <Route path="*" element={<Breadcrumbs />} />
            </Routes>
          </BrowserRouter>
        </Provider>
      );
    }
  }
}

document.addEventListener('DOMContentLoaded', init);
